import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const updateFAQAction = createAsyncThunk(
    'update-FAQ',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/support-server/api/support-knowladge`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateFAQSlice = createSlice({
    name: 'update-FAQ',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateFAQAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateFAQAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateFAQAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateFAQReducer = updateFAQSlice.reducer    